import { render, staticRenderFns } from "./FoldersPage.vue?vue&type=template&id=18896398"
import script from "./FoldersPage.vue?vue&type=script&lang=js"
export * from "./FoldersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports